<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { AVAILABLE_LOCALES, LOCALE_LABELS } from '../i18n/locales'
import LogoComponent from '@webapp/components/AppComponents/LogoComponent/LogoComponent.vue'
import AppNameComponent from '@webapp/components/AppComponents/LogoComponent/AppNameComponent.vue'
import AppFooter from './AppFooter.vue'
import LegalModal from './LegalModal.vue'

const { locale } = useI18n()
const legalType = ref(null)

const changeLocale = (event) => {
    const val = event.target.value
    locale.value = val
    localStorage.setItem('timebrella-locale', val)
}
</script>

<template>
  <div class="mp-auth-container">
    <div class="mp-auth-card">
      <div class="mp-lang-selector">
        <select class="form-select form-select-sm" :value="locale" @change="changeLocale">
          <option v-for="loc in AVAILABLE_LOCALES" :key="loc" :value="loc">
            {{ LOCALE_LABELS[loc] || loc }}
          </option>
        </select>
      </div>
      <div class="mp-logo-wrapper">
        <LogoComponent class="img-fluid mp-logo" />
        <h4>
          <AppNameComponent />
        </h4>
      </div>
      <router-view />
    </div>
    <AppFooter @open-legal="legalType = $event" />
  </div>
  <LegalModal :type="legalType" @close="legalType = null" />
</template>

<style>
.mp-auth-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mp-auth-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mp-logo {
  max-width: 128px;
  display: inline-block;
}
.mp-lang-selector {
  text-align: right;
  margin-bottom: 0.5rem;
}
.mp-lang-selector .form-select {
  width: auto;
  display: inline-block;
  font-size: 0.85rem;
}
</style>
